import Layout from "@/components/layout/Layout";
import SectionHeader from "@/components/feature/SectionHeader";
import { vipTiers, testimonials } from "@/mocks/comics";

const allPerks = [
  "畅读尊享漫画全库",
  "钻石漫画独占首发",
  "抢先看最新章节",
  "豪华画质原图",
  "去广告纯净阅读",
  "稀有番外专属阅读",
  "尊贵头像边框标识",
  "生日豪礼与专属客服",
  "线下活动优先资格",
];

function VipPage() {
  return (
    <Layout
      title="会员特权-尊享会员|钻石会员|贵族会员|专属特权阅读|土豪漫画网"
      description="土豪漫画网会员特权：尊享会员、钻石会员、贵族会员专属特权阅读，畅读尊享漫画、钻石漫画等全库专属内容，豪华画质，尊贵体验。"
    >
      <section className="relative overflow-hidden pt-28 md:pt-36 pb-10 text-center">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-b from-primary-900/30 via-background-950 to-background-950"></div>
          <div className="absolute left-1/2 top-6 h-80 w-80 -translate-x-1/2 rounded-full bg-primary-500/15 blur-3xl"></div>
        </div>
        <div className="relative mx-auto max-w-4xl px-4 md:px-6">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-primary-500/10 px-4 py-1.5 text-xs font-semibold tracking-widest text-primary-300">
            <i className="ri-vip-diamond-fill"></i>
            VIP PRIVILEGES
          </span>
          <h1 className="mt-6 font-heading text-3xl font-black text-foreground-50 md:text-5xl">
            开启贵族<span className="text-gold-grad">专属特权</span>
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-foreground-400 md:text-base">
            尊享会员、钻石会员、贵族会员三档特权任你选择，畅读尊享漫画、钻石漫画等全库专属内容，豪华画质、抢先更新、纯净阅读，尊贵体验一步到位。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-6 md:py-12">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {vipTiers.map((tier) => (
            <div
              key={tier.name}
              className={`relative flex flex-col rounded-xl border p-8 transition hover:-translate-y-1 ${
                tier.highlight
                  ? "border-primary-500/60 bg-gradient-to-b from-primary-500/15 to-background-950 shadow-xl shadow-primary-900/20"
                  : "border-background-800 bg-background-900/60"
              }`}
            >
              {tier.highlight && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-gradient-to-r from-primary-500 to-accent-500 px-4 py-1 text-xs font-bold text-foreground-950">
                  {tier.highlight}
                </span>
              )}
              <span className={`inline-flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br ${tier.color} text-2xl text-foreground-950`}>
                <i className={tier.icon}></i>
              </span>
              <h3 className="mt-5 font-heading text-2xl font-bold text-foreground-50">{tier.name}</h3>
              <div className="mt-4 flex items-end gap-1">
                <span className="font-heading text-4xl font-black text-gold-grad">{tier.price}</span>
                <span className="mb-1 text-sm text-foreground-500">{tier.period}</span>
              </div>
              <ul className="mt-6 flex-1 space-y-3 border-t border-background-800 pt-6">
                {tier.perks.map((perk) => (
                  <li key={perk} className="flex items-center gap-2 text-sm text-foreground-300">
                    <i className="ri-check-line text-primary-400"></i>
                    {perk}
                  </li>
                ))}
              </ul>
              <span
                className={`mt-7 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-6 py-3 text-sm font-semibold transition cursor-pointer ${
                  tier.highlight
                    ? "bg-gradient-to-r from-primary-500 to-accent-500 text-foreground-950 hover:from-primary-400 hover:to-accent-400"
                    : "border border-primary-500/50 text-primary-300 hover:bg-primary-500/10"
                }`}
              >
                立即开通
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <SectionHeader
          eyebrow="Compare"
          title="特权对比一览"
          desc="清晰了解三档会员各自的专属权益，选择最适合你的尊贵阅读方案。"
          align="center"
        />
        <div className="mt-10 overflow-hidden rounded-xl border border-background-800">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[640px] text-left text-sm">
              <thead>
                <tr className="border-b border-background-800 bg-background-900/70">
                  <th className="px-5 py-4 font-heading text-foreground-100">专属权益</th>
                  <th className="px-5 py-4 font-heading text-foreground-100">尊享会员</th>
                  <th className="px-5 py-4 font-heading text-primary-300">钻石会员</th>
                  <th className="px-5 py-4 font-heading text-accent-300">贵族会员</th>
                </tr>
              </thead>
              <tbody>
                {allPerks.map((perk) => (
                  <tr key={perk} className="border-b border-background-900 last:border-0">
                    <td className="px-5 py-3.5 text-foreground-300">{perk}</td>
                    <td className="px-5 py-3.5">
                      {["畅读尊享漫画全库", "抢先看最新章节", "豪华画质原图", "去广告纯净阅读"].includes(perk) ? (
                        <i className="ri-check-line text-primary-400"></i>
                      ) : (
                        <i className="ri-close-line text-foreground-700"></i>
                      )}
                    </td>
                    <td className="px-5 py-3.5">
                      {["畅读尊享漫画全库", "抢先看最新章节", "豪华画质原图", "去广告纯净阅读", "钻石漫画独占首发", "稀有番外专属阅读", "尊贵头像边框标识"].includes(perk) ? (
                        <i className="ri-check-line text-primary-400"></i>
                      ) : (
                        <i className="ri-close-line text-foreground-700"></i>
                      )}
                    </td>
                    <td className="px-5 py-3.5">
                      <i className="ri-check-line text-accent-400"></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 pb-16">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {testimonials.slice(0, 4).map((t) => (
            <figure
              key={t.name}
              className="rounded-lg border border-background-800 bg-background-900/50 p-6 transition hover:border-primary-500/40"
            >
              <blockquote className="text-sm leading-7 text-foreground-400">“{t.content}”</blockquote>
              <figcaption className="mt-4 text-sm font-semibold text-primary-300">
                {t.name} · {t.level}
              </figcaption>
            </figure>
          ))}
        </div>
      </section>
    </Layout>
  );
}

export default VipPage;